// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2kKvl","description":"PatientConsentPreview_description__30D6h"};